module.exports = __webpack_public_path__ + "img/pasta_al_forno_piselli.004353cc.jpg";